import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import api from "../lib/api";

const STEPS = [["need", "The need", "What was happening?"], ["intervention", "The intervention", "What did DKF do?"], ["result", "The result", "What changed?"], ["follow_up", "The follow-up", "What happened after 3, 6 or 12 months?"]];

export const ImpactStories = () => {
  const [stories, setStories] = useState([]);
  useEffect(() => { api.get("/stories").then((r) => setStories(r.data)).catch(() => {}); }, []);
  if (stories.length === 0) return null;
  return (
    <section className="py-20 md:py-24 bg-white" data-testid="impact-stories">
      <div className="dk-container">
        <div className="max-w-3xl mb-12">
          <span className="text-[#0d1724] tracking-[0.3em] text-xs font-semibold uppercase">Stories of impact</span>
          <h2 className="font-serif text-[#0a0d12] text-3xl md:text-5xl font-bold mt-3">Need. Intervention. Result. Follow-up.</h2>
          <p className="text-[#0a0d12]/70 mt-4">Every story is published with the consent of the people involved and followed up months later — because outputs are not the same as impact.</p>
        </div>
        <div className="space-y-12">
          {stories.map((s, i) => (
            <article key={s.id} className={`grid lg:grid-cols-5 gap-8 items-start ${i % 2 ? "lg:[&>*:first-child]:order-last" : ""}`} data-testid={`story-${i}`}>
              <div className="lg:col-span-2">
                {s.image_url && <div className="relative"><img src={s.image_url} alt={s.image_is_real ? s.title : ""} loading="lazy" className="rounded-2xl w-full h-72 object-cover" />{!s.image_is_real && <span className="absolute bottom-3 left-3 text-[10px] uppercase tracking-wider text-white bg-black/60 px-2 py-1 rounded">Illustrative image — not the beneficiary</span>}</div>}
                <div className="mt-4 flex items-center gap-3 text-xs text-[#0a0d12]/60 uppercase tracking-wider">{s.programme}{s.location && <span className="flex items-center gap-1"><MapPin size={12} /> {s.location}</span>}</div>
                <h3 className="font-serif text-2xl md:text-3xl font-bold text-[#0a0d12] mt-2">{s.title}</h3>
                {s.project_serial && <Link to={`/projects/${s.project_serial}/trace`} className="text-xs font-mono underline text-[#0d1724] mt-2 inline-block">{s.project_serial}</Link>}
              </div>
              <ol className="lg:col-span-3 grid sm:grid-cols-2 gap-4">
                {STEPS.map(([k, t, q], j) => s[k] && (
                  <li key={k} className={`p-6 rounded-2xl border ${k === "follow_up" ? "bg-[#155e3f] text-white border-transparent" : "bg-[#f8f4e8] border-[#d6aa43]/15"}`}>
                    <div className={`text-[10px] font-mono ${k === "follow_up" ? "text-[#d6aa43]" : "text-[#d6aa43]"}`}>0{j + 1} · {t}{k === "follow_up" && s.follow_up_period ? ` · ${s.follow_up_period}` : ""}</div>
                    <div className={`text-xs italic mt-1 ${k === "follow_up" ? "text-white" : "text-[#0a0d12]/60"}`}>{q}</div>
                    <p className={`text-sm mt-3 leading-relaxed ${k === "follow_up" ? "text-white" : "text-[#0a0d12]/85"}`}>{s[k]}</p>
                  </li>
                ))}
              </ol>
            </article>
          ))}
        </div>
        <p className="text-xs text-[#0a0d12]/60 mt-10">Names, addresses, children's information, medical and financial details are never published without appropriate consent.</p>
      </div>
    </section>
  );
};
